import React from 'react';
import './DividerPreview.scss';

const DividerPreview = props => {
	const { from, divider } = props;
	const { color, size, source, type = 'solid' } = (divider && divider.props) || {};

	const fromButton = from === 'WidgetButton';
	const height = size === 'small' ? '2px' : size === 'medium' ? '4x' : '6px';

	return (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : null}>
				{!from && (
					<div className="hover-container" style={{ margin: '0 .5rem' }}>
						Divider
					</div>
				)}
				<div
					className="divider-preview"
					style={{ backgroundColor: fromButton ? 'white' : 'transparent' }}
				>
					<div className="line-container" style={{ margin: '0 .5rem' }}>
						{type === 'solid' ? (
							<div
								className={`divider-line`}
								style={{ backgroundColor: color, height: fromButton ? '4px' : height }}
							/>
						) : type === 'dashed' ? (
							<hr
								className="divider-dashed-line"
								style={{ borderTopColor: color, borderTopWidth: height }}
							/>
						) : (
							<img
								src={source.src}
								style={{
									width: '100%',
									height: '100%',
									objectFit: 'contain',
								}}
								alt={source.name}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default DividerPreview;
